const dateHelper = {
    monthName: [
        {
            id: '01',
            name: 'январь'
        },
        {
            id: '02',
            name: 'февраль'
        },
        {
            id: '03',
            name: 'март'
        },
        {
            id: '04',
            name: 'апрель'
        },
        {
            id: '05',
            name: 'май'
        },
        {
            id: '06',
            name: 'июнь'
        },
        {
            id: '07',
            name: 'июль'
        },
        {
            id: '08',
            name: 'август'
        },
        {
            id: '09',
            name: 'сентябрь'
        },
        {
            id: '10',
            name: 'октябрь'
        },
        {
            id: '11',
            name: 'ноябрь'
        },
        {
            id: '12',
            name: 'декабрь'
        }
    ],
    getMonthName: (monthNumber) => {
        return dateHelper.monthName.filter(item => item.id === monthNumber).map(item => item.name);
    }
};

export default dateHelper;
